import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../../../../utils/UtilsFormule";
import * as XLSX from "xlsx";

import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

const DataAvancesList = ({ listTransaction }) => {
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  // const MyExportCSV = (props) => {
  //   const handleClick = () => {
  //     props.onExport();
  //   };
  //   return (
  //     <div>
  //       <button className="btn btn-dark" onClick={handleClick}>
  //         <i class="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };

  const CustomExportButton = ({ data, fileName }) => {
    const handleExport = () => {
      console.log("data", data);
      // Filter the data to include only the required fields
      const filteredData = data.map((item) => ({
        Mois: item.month + "-" + item.year,
        Ref: (() => {
          if (item.typePayement === "Espéce") {
            return item.refPayementInfo + "-" + item.yearPayementInfo;
          } else if (item.typePayement === "Virement") {
            return item.numVirement || "";
          } else if (item.typePayement === "Chéque / Traites") {
            return item.codeCheque || "";
          } else {
            return "en ligne";
          }
        })(), // Immediately invoke the function
        Type: item.typePayement,
        Echéance: (() => {
          if (
            item.typePayement === "Espéce" ||
            item.typePayement === "En ligne"
          ) {
            return UtilsFormule.formatDate(item.creationDate);
          } else if (
            item.typePayement === "Virement" ||
            item.typePayement === "Chéque / Traites"
          ) {
            return UtilsFormule.formatDate(item.echeanceDate);
          } else {
            return UtilsFormule.formatDate(item.creationDate);
          }
        })(),
        "M.payé": item.amountPayed,
        Employé:
          item.employe.cin +
          "-" +
          item.employe.firstName +
          " " +
          item.employe.lastName,
      }));

      // Convert the filtered data to a worksheet
      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Export the workbook to an Excel file
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    return (
      <button onClick={handleExport} className="btn btn-dark">
        <i className="fas fa-download"></i> Télécharger Excel
      </button>
    );
  };

  function documentTypeFormatter(cell, row) {
    console.log("row", row);
    return (
      <span style={{ cursor: "pointer" }} className="badge bg-success">
        {" "}
        Avance
      </span>
    );
  }

  function RefPayementFormatter(cell, row) {
    // console.log("row", row);

    if (row.typePayement === "Espéce") {
      return (
        <span>
          {row.refPayementInfo}-{row.yearPayementInfo}
        </span>
      );
    } else if (row.typePayement === "Virement") {
      return <span>{row.numVirement}</span>;
    } else if (row.typePayement === "Chéque / Traites") {
      return <span>{row.codeCheque}</span>;
    } else {
      return <span>en ligne</span>;
    }
  }

  function moisRefFormatter(cell, row) {
    console.log("row", row);

    return (
      <span>
        {row.month}-{row.year}
      </span>
    );
  }
  function documentRefFormatter(cell, row) {
    if (row.employe !== null) {
      return (
        <span>
          {row.employe.cin}-{row.employe.firstName} {row.employe.lastName}
        </span>
      );
    }
  }
  function filePayementFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-gray btn-sm "
        onClick={() => onShowFileInOtherWizndowHandler(row.urlFile)}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  function dateFormatter(cell, row) {
    console.log("row", row);

    if (row.typePayement === "Espéce" || row.typePayement === "En ligne") {
      return <span>{UtilsFormule.formatDate(row.creationDate)}</span>;
    } else if (
      row.typePayement === "Virement" ||
      row.typePayement === "Chéque / Traites"
    ) {
      return <span>{UtilsFormule.formatDate(row.echeanceDate)}</span>;
    }
  }

  const columns = [
    {
      dataField: "idPayementInfo",
      text: "",
      align: "center",
      formatter: documentTypeFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "idPayementInfo",
      text: "Mois ",
      align: "center",
      formatter: moisRefFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "idPayementInfo",
      text: "Ref ",
      align: "center",
      formatter: RefPayementFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },

    {
      dataField: "typePayement",
      text: "Type",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "idPayementInfo",
      text: "Echeance",
      formatter: dateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "amountPayed",
      text: "M.Payé",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "idPayementInfo",
      text: "Employé",
      formatter: documentRefFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "idPayementInfo",
      text: "Fichier",
      formatter: filePayementFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];
  const especeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Espèce</td>
                <td>
                  {row.refPayementInfo}-{row.yearPayementInfo}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Espèce</td>
                <td>
                  {row.refPayementInfo}-{row.yearPayementInfo}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Espèce</td>
              <td>
                {row.refPayementInfo}-{row.yearPayementInfo}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const enLigneInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>En ligne</td>
                <td>
                  {row.refPayementInfo}-{row.yearPayementInfo}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>En ligne</td>
                <td>
                  {" "}
                  {row.refPayementInfo}-{row.yearPayementInfo}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>En ligne</td>
              <td>
                {row.refPayementInfo}-{row.yearPayementInfo}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const virementInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Virement</td>
              <td>{row.numVirement}</td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const chequeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
                {/* <th style={{ width: "15%" }}>Payer</th> */}
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
                {/* <td className="text-center">  <button
                                style={{ width: 40 }}
                                class="btn bg-success btn-sm "
                                data-toggle="modal"
                                data-target="#add-payement"
                                onClick={() =>
                                    onAddPayementHandler(
                                        row.idPayementInfo
                                    )
                                }
                            >
                                <i class="fas fa-check"></i>
                            </button> </td> */}
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref.Cheque</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
              {/* <th style={{ width: "15%" }}>Payer</th>
                    <th style={{ width: "15%" }}>Rejeter</th> */}
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Chèque/ traites</td>
              <td>{row.codeCheque}</td>

              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
              {/* <td className="text-center">  <button
                        style={{ width: 40 }}
                        class="btn bg-success btn-sm "
                        data-toggle="modal"
                        data-target="#add-payement"
                        onClick={() =>
                            onAddPayementHandler(
                                row.idPayementInfo
                            )
                        }
                    >
                        <i class="fas fa-check"></i>
                    </button> </td>
                    <td className="text-center">  <button
                        style={{ width: 40 }}
                        class="btn bg-danger btn-sm "
                        data-toggle="modal"
                        data-target="#rejeter-payement"
                        onClick={() =>
                            onAddRejeterHandler(
                                row.idPayementInfo
                            )
                        }
                    >
                        <i class="fas fa-xmark"></i>
                    </button> </td> */}
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const expandRow = {
    renderer: (row) => (
      <div>
        {row.typePayement === "Espéce" && especeInfo(row)}
        {row.typePayement === "En ligne" && enLigneInfo(row)}
        {row.typePayement === "Chéque / Traites" && chequeInfo(row)}
        {row.typePayement === "Virement" && virementInfo(row)}
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les avances </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="idPayementInfo"
          data={listTransaction}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                {/* <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div> */}
                <div className="ml-auto mr-0">
                  <CustomExportButton
                    data={listTransaction}
                    fileName="avances"
                  />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default DataAvancesList;
